import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { Checkbox, Modal, Tooltip, Button, Form, Radio, message } from 'antd';

import close from '../../assets/RoundedClose.svg';
import done from '../../assets/Done, Check.svg';
import ServiceComponentsIcon from '../../assets/ServiceComponentsIcon.png';
import InfoIcon from '../Icons/infoIcon';
import { useDiscardKikOffFormChangesMutation, useSaveKikOffFormMutation } from '../../api/tenders';
import { Loader } from '../Loader/Loader';
import { yupSync } from '../../utils';
import * as Yup from 'yup';
import { CustomMultiSelect } from '../Fields/CustomMultiSelect';
import { FloatSelect } from '../Fields/FloatSelect';
import { useGetSchoolTypesQuery } from '../../api/common';

import { FloatInput } from '../Fields/FloatInput';
import { FloatTextArea } from '../Fields/FloatTextArea';
import i from '../../assets/i.svg';
import { FilePicker } from '../Fields/FilePicker';
import { createAbortController } from '../../api/axiosCruds';
import { uploadFileKikOff } from '../../api/axiosCruds';
import { WarningTriangle } from '../Icons/WarningTriangle';
import { CheckCircle } from '../Icons/CheckCircle';
import ArrowDown from '../Icons/ArrowDown';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import { useAppSelector } from '../../hooks';
import NeedReviewByTR from '../../assets/NeedReviewByTR.png';
import Edit from '../Icons/Edit';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    formData: any;
    tender_id: number;
    task_id: string | number | null;
    getFormData: (step: null | number) => void;
    setTrigger: Dispatch<SetStateAction<boolean>>;
    tenderData: tenderDataProps;
}

export interface SaveData {
    id: number;
    slug: string;
    title: string;
    description: string;
    fields: FieldI[];
}

export interface FieldI {
    id: number;
    slug: string;
    type: string;
    label: string;
    description: string;
    options: any[];
    settings: { type: string; switchValue: boolean }[];
    order: number;
    answer: string | number[] | null | number;
    component_id?: number | null;
}

const fieldInstanceKey = (id: number, componentId?: number | null) =>
    `${id}__${componentId == null ? 'null' : componentId}`;

const isSameFieldInstance = (
    field: { id: number; component_id?: number | null },
    id: number,
    componentId?: number | null
) => field.id === id && (field.component_id ?? null) === (componentId ?? null);

const NeedReview = () => {
    return (
        <div className="need-review">
            <img src={NeedReviewByTR} /> Needs Review
        </div>
    );
};

const validationSchema = Yup.object().shape({
    contact_name: Yup.string().required('This is a required field'),
    first_name: Yup.string().required('This is a required field'),
    name: Yup.string().required('This is a required field'),
    trading_name: Yup.string(),
    website: Yup.string()
        .required('This is a required field')
        .matches(/^(https?:\/\/)/, 'Oops! Your link is not correct'),
    last_name: Yup.string().required('This is a required field'),
    email: Yup.string().email('Enter your email: e.g. email@domain.com').required('This is a required field'),
    secondary_email: Yup.string().email('Enter your email: e.g. email@domain.com'),
    school: Yup.object().required('This is a required field'),
    b_bbee: Yup.object().required('This is a required field'),
    annual_revenue: Yup.object().required('This is a required field'),
    employees_number: Yup.object().required('This is a required field'),
    sub_regions: Yup.object().required('This is a required field'),
    job: Yup.string().required('This is a required field'),
    phone_number: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),
    registration_num: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),
    vat_number: Yup.string()
        .required('This is a required field')
        .matches(/^[^_]*$/, 'This is a required field'),

    password: Yup.string()
        .required('This is a required field')
        .test('password-requirements', '', (value) => {
            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
            return passwordRegex.test(value);
        }),
    confirmPassword: Yup.string().required('This is a required field')
});

export const KikOffQuestionaryModal: FC<ModalProps> = ({
    openModal,
    setOpenModal,
    formData,
    tender_id,
    task_id,
    getFormData,
    setTrigger,
    tenderData
}) => {
    const { role } = useAppSelector((state) => state.profileReducer);

    const { steps, form_data, service_components, suppliers_count, progress_data } = formData;
    const [abortController, setAbortController] = useState<AbortController | null>(null);
    const [loadingType, setLoadingType] = useState('');

    const [saveData, setSaveData] = useState<any>();
    const [errorFields, setErrorFields] = useState<string[]>([]);
    const [errorFiles, setErrorFiles] = useState<{ key: string; error: string }[]>([]);

    const types = {};
    const [saveKikOff, { isLoading: isLoadingSave, isError, error, isSuccess }] = useSaveKikOffFormMutation();
    const [discardKikOffChanges, { isLoading: isLoadingDiscard }] = useDiscardKikOffFormChangesMutation();
    const { data: dataSchoolTypes } = useGetSchoolTypesQuery(types);

    const isServiceComponents = saveData?.fields?.[0]?.slug === 'service_components';

    const [subRegionsOptions, setSubregionsOptions] = useState<any>([]);
    const [filtredSubRegion, setFiltredSubRegion] = useState<any>([]);
    const [filteredAnnual, setFilteredAnnual] = useState([]);
    const [filteredEmpl, setFilteredEmpl] = useState([]);
    const [filteredProvincial, setFilteredProvincial] = useState([]);
    const [filteredBBE, setFilteredBBE] = useState<string[]>([]);

    console.log('filtredSubRegion', filtredSubRegion);
    console.log('subRegionsOptions', subRegionsOptions);

    const viewMod = tenderData?.phase_tasks?.find((elem) => elem.action === 'design_phase_questionnaire');

    const isTREditingForSU =
        (tenderData?.phase_tasks?.find((elem) => elem.action === 'define_phase_questionnaire')?.status ===
            'need_approve_tr' &&
            role === 'school_user') ||
        (viewMod?.status === 'completed' && role === 'school_user');

    const isTREditingTR = role === 'tender_representative';

    const editedField = progress_data?.edited_fields;

    const [form] = Form.useForm();

    const SelectedProvince: any = saveData?.fields?.find((elem: any) => elem.slug === 'provincial_coverage')?.answer;
    const SelectedAnnual: any = saveData?.fields?.find((elem: any) => elem.slug === 'annual_revenue')?.answer;
    const SelectedEmpl: any = saveData?.fields?.find((elem: any) => elem.slug === 'number_employees')?.answer;
    const SelectedBBE: any = saveData?.fields?.find((elem: any) => elem.slug === 'b_bbee')?.answer;
    const SelectedSubRegions: any = saveData?.fields?.find((elem: any) => elem.slug === 'sub_region')?.answer;

    useEffect(() => {
        if (isSuccess) {
            const activeIndex = steps.findIndex((step: any) => step.is_active);

            const isLastStep = activeIndex === steps.length - 1;
            if (isLastStep) {
                setOpenModal(false);
                setTrigger((prev) => !prev);
                message.success('Your changes have been saved successfully');
            }
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            //@ts-ignore
            message.error(error?.data?.message);
        }
    }, [isError]);

    useEffect(() => {
        if (SelectedAnnual) {
            if (dataSchoolTypes?.data?.sc_annual_revenue) {
                const annual = [...dataSchoolTypes?.data?.sc_annual_revenue];
                const filteredArray: any = annual.filter((item) => !SelectedAnnual.includes(item.id));
                setFilteredAnnual(filteredArray);
            }
        } else {
            setFilteredAnnual(dataSchoolTypes?.data?.sc_annual_revenue);
        }
    }, [dataSchoolTypes?.data?.sc_annual_revenue, SelectedAnnual]);

    useEffect(() => {
        if (SelectedProvince) {
            if (dataSchoolTypes?.data?.provinces) {
                const empl = [...dataSchoolTypes?.data?.provinces];
                const filteredArray: any = empl.filter((item) => !SelectedProvince.includes(item.id));
                setFilteredProvincial(filteredArray);
            }
        } else {
            setFilteredProvincial(dataSchoolTypes?.data?.provinces);
        }
    }, [dataSchoolTypes?.data?.provinces, SelectedProvince]);

    useEffect(() => {
        if (!dataSchoolTypes?.data?.provinces) return;

        const provinces = [...dataSchoolTypes?.data?.provinces];

        let subRegionsArray: any[] = [];

        provinces.forEach((elem) => {
            if (SelectedProvince?.includes(elem.id)) {
                subRegionsArray.push(...elem.sub_regions);
            }
        });
        const filteredArraySubRegions: any = subRegionsArray.filter((item) => !SelectedSubRegions?.includes(item.id));

        setFiltredSubRegion(filteredArraySubRegions);
        setSubregionsOptions(subRegionsArray);
    }, [SelectedProvince, SelectedSubRegions]);

    useEffect(() => {
        if (SelectedEmpl) {
            if (dataSchoolTypes?.data?.sc_employees_number) {
                const empl = [...dataSchoolTypes?.data?.sc_employees_number];
                const filteredArray: any = empl.filter((item) => !SelectedEmpl.includes(item.id));
                setFilteredEmpl(filteredArray);
            }
        } else {
            setFilteredEmpl(dataSchoolTypes?.data?.sc_employees_number);
        }
    }, [dataSchoolTypes?.data?.sc_employees_number, SelectedEmpl]);

    useEffect(() => {
        if (filteredBBE) {
            if (dataSchoolTypes?.data?.sc_b_bbee) {
                const empl = [...dataSchoolTypes?.data?.sc_b_bbee];
                const filteredArray: any = empl.filter((item) => !SelectedBBE?.includes(item.id));
                setFilteredBBE(filteredArray);
            }
        } else {
            setFilteredBBE(dataSchoolTypes?.data?.sc_b_bbee);
        }
    }, [dataSchoolTypes?.data?.sc_b_bbee, SelectedBBE]);

    const handleUpdateAnswer = (fieldId: number, value: string | number, componentId?: number | null) => {
        setSaveData((prev: any) => {
            if (!prev) return prev;

            return {
                ...prev,
                fields: prev.fields.map((field: any) => {
                    if (!isSameFieldInstance(field, fieldId, componentId)) return field;

                    if (field.type === 'multiple-choice') {
                        const current = Array.isArray(field.answer) ? field.answer : [];
                        const exists = current.includes(value);

                        return {
                            ...field,
                            answer: exists ? current.filter((v: any) => v !== value) : [...current, value]
                        };
                    }

                    return {
                        ...field,
                        answer: String(value)
                    };
                })
            };
        });
    };

    const handleUpdateSuppInfo = (
        fieldId: number,
        value: any,
        type?: string,
        slug?: string,
        options?: any[],
        componentId?: number | null
    ) => {
        const errors = [...errorFields];
        const newErrors = errors.filter((item) => item !== fieldInstanceKey(fieldId, componentId));

        setErrorFields(newErrors);

        setSaveData((prev: any) => {
            if (!prev) return prev;

            return {
                ...prev,
                fields: prev.fields.map((field: any) => {
                    if (isSameFieldInstance(field, fieldId, componentId)) {
                        if (type === 'multiple') {
                            const current = Array.isArray(field.answer) ? field.answer : [];

                            if (value === 'selectedAll') {
                                const allValues = options?.map((o: any) => o.id) || [];
                                return {
                                    ...field,
                                    answer: allValues
                                };
                            }

                            const exists = current.includes(value);
                            return {
                                ...field,
                                answer: exists ? current.filter((v: any) => v !== value) : [...current, value]
                            };
                        } else if (type === 'single') {
                            return {
                                ...field,
                                answer: value === true ? 1 : value === false ? 0 : null
                            };
                        }

                        return {
                            ...field,
                            answer: [value]
                        };
                    }

                    if (slug === 'province' && field.slug === 'sub_region') {
                        return {
                            ...field,
                            answer: null
                        };
                    }

                    return field;
                })
            };
        });
    };

    const validateRequiredFields = (saveData: SaveData | null) => {
        if (!saveData) {
            return { isValid: false, invalidFields: [] };
        }

        const invalidFields: string[] = [];

        for (const field of saveData.fields) {
            const requiredSetting = field.settings.find((s) => s.type === 'required');

            if (!requiredSetting || !requiredSetting.switchValue) continue;

            const answer = field.answer;

            let isFieldValid = true;

            if (saveData?.slug === 'supplier_information') {
                if (field.slug === 'vat_registered') {
                    isFieldValid = answer === 1 || answer === 0 ? true : false;
                } else {
                    isFieldValid = Array.isArray(answer) && answer.length > 0;
                }

                if (!isFieldValid) {
                    invalidFields.push(fieldInstanceKey(field.id, field.component_id));
                }
            } else if (saveData.slug === 'evaluation_criteria') {
                if (field.type === 'slider') {
                    isFieldValid = !!answer;
                }
                if (!isFieldValid) {
                    invalidFields.push(fieldInstanceKey(field.id, field.component_id));
                }
            } else {
                if (field.type === 'multiple-choice' || field.type === 'dropdown') {
                    isFieldValid = Array.isArray(answer) && answer.length > 0;
                } else if (field.type === 'file-upload') {
                    isFieldValid = !!answer;
                } else {
                    isFieldValid = typeof answer === 'string' && answer.trim().length > 0;
                }

                if (!isFieldValid) {
                    invalidFields.push(fieldInstanceKey(field.id, field.component_id));
                }
            }
        }

        return {
            isValid: invalidFields.length === 0,
            invalidFields
        };
    };

    const saveForm = (type?: string | null) => {
        const { isValid, invalidFields } = validateRequiredFields(saveData);

        setErrorFields(invalidFields);

        const items = [...steps];
        const activeStep = items.find((item) => item.is_active)?.key;

        const baseData: {
            tender_id: number;
            task_id: string | number | null;
            formData: any;
            step: any;
            action?: string;
        } = {
            tender_id: tender_id,
            task_id: task_id,
            formData: saveData,
            step: activeStep
        };

        if (type === 'save_and_exit') {
            setLoadingType('save_and_exit');

            saveKikOff(baseData).then(() => {
                setLoadingType('save_and_exit');
                message.success('Your changes have been saved successfully');
                setTrigger((prev) => !prev);
                setOpenModal(false);
            });
        } else if (type === 'next') {
            setLoadingType('next');
            baseData.action = 'next_step';

            if (isValid) {
                saveKikOff(baseData).then(() => {
                    getFormData(null);
                });
            }
        }
    };

    const handleDiscardChanges = async () => {
        const activeStep = steps.find((item: any) => item.is_active)?.key;

        if (task_id == null || activeStep == null) {
            setOpenModal(false);
            return;
        }

        try {
            await discardKikOffChanges({
                tender_id,
                task_id,
                step: activeStep
            }).unwrap();
            message.success('Changes discarded');
            setTrigger((prev) => !prev);
            setOpenModal(false);
        } catch (err: any) {
            message.error(err?.data?.message ?? 'Could not discard changes');
        }
    };

    useEffect(() => {
        if (form_data) {
            setSaveData({ ...form_data });
        }
    }, [form_data]);

    const updateAnswer = (id: number, value: any, componentId?: number | null) => {
        const errors = [...errorFields];
        const newErrors = errors.filter((item) => item !== fieldInstanceKey(id, componentId));

        setErrorFields(newErrors);

        setSaveData((prev: any) => {
            if (!prev) return prev;

            return {
                ...prev,
                fields: prev.fields.map((field: any) => {
                    if (isSameFieldInstance(field, id, componentId)) {
                        if (field.type === 'dropdown') {
                            return {
                                ...field,
                                answer: [value]
                            };
                        } else if (field.type === 'multiple-choice') {
                            const current = Array.isArray(field.answer) ? field.answer : [];
                            const exists = current.includes(value);

                            return {
                                ...field,
                                answer: exists ? current.filter((v: any) => v !== value) : [...current, value]
                            };
                        } else {
                            return {
                                ...field,
                                answer: value
                            };
                        }
                    }

                    return field;
                })
            };
        });
    };

    const deleteFile = (field_id: number, componentId?: number | null) => {
        setSaveData((prev: any) => {
            if (!prev) return prev;

            return {
                ...prev,
                fields: prev.fields.map((field: any) => {
                    if (!isSameFieldInstance(field, field_id, componentId)) return field;

                    return {
                        ...field,
                        answer: null
                    };
                })
            };
        });
    };

    const uploadFileHandler = async (
        fileList: any[],
        section_id: number,
        field_id: number,
        component_id?: number | null
    ) => {
        const fileFieldKey = fieldInstanceKey(field_id, component_id);
        const errors = [...errorFields];
        const newErrors = errors.filter((item) => item !== fileFieldKey);

        setErrorFields(newErrors);
        setErrorFiles((prev) => [
            ...prev,
            {
                key: fileFieldKey,
                error: ''
            }
        ]);
        // setIsLoading(true);
        try {
            const abortController = createAbortController();
            if (
                fileList[0]
                // && (!fileErr || fileErr === 'Upload failed. Check your internet connection')
            ) {
                const contentFile: any = fileList?.[0]?.originFileObj;
                const fileData = new FormData();

                const fileObj: File = contentFile;
                const fileName: string = fileObj?.name;

                fileData.append('file', fileObj, fileName);
                fileData.append('section_id', section_id.toString());
                fileData.append('field_id', field_id.toString());
                fileData.append('component_id', component_id ? component_id?.toString() : '');

                const items = [...steps];

                const activeStep = items.find((item) => item.is_active)?.key;

                const datatoPost: any = {
                    tender_id: tender_id,
                    task_id: task_id,
                    step: activeStep,
                    data: fileData
                };

                if (abortController) {
                    abortController.abort();
                }

                const newAbortController = createAbortController();
                setAbortController(newAbortController);

                const signal = newAbortController.signal;

                const response = await uploadFileKikOff(datatoPost, signal);

                setSaveData((prev: any) => {
                    if (!prev) return prev;

                    return {
                        ...prev,
                        fields: prev.fields.map((field: any) => {
                            if (!isSameFieldInstance(field, field_id, component_id)) return field;

                            return {
                                ...field,
                                answer: response.data.data
                            };
                        })
                    };
                });
            }
        } catch (error: any) {
            setErrorFiles((prev) => [
                ...prev,
                {
                    key: fileFieldKey,
                    error: error?.response?.data?.message
                }
            ]);
        }
    };

    return (
        <>
            <Modal
                className="questionary_modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => {}}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={<></>}
            >
                <div className="modal questionary_modal_wrapper">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Kick-off Questionnaire</div>
                    </div>

                    {viewMod ? (
                        <></>
                    ) : (
                        <div
                            className={`modal__supp-count supp-count supp-count-modal ${
                                suppliers_count <= 5
                                    ? 'warning'
                                    : suppliers_count >= 6 && suppliers_count <= 9
                                    ? 'yellow'
                                    : suppliers_count >= 10
                                    ? 'green'
                                    : ''
                            }`}
                        >
                            <div className="supp-count-title">
                                {suppliers_count <= 5 && (
                                    <>
                                        <WarningTriangle /> {suppliers_count}{' '}
                                        {suppliers_count === 1 ? 'supplier' : 'suppliers'} match
                                    </>
                                )}
                                {suppliers_count >= 6 && suppliers_count <= 9 && (
                                    <>
                                        <InfoIcon fill="#E64A0D" /> {suppliers_count}{' '}
                                        {suppliers_count === 1 ? 'supplier' : 'suppliers'} match
                                    </>
                                )}
                                {suppliers_count >= 10 && (
                                    <>
                                        <CheckCircle /> More than 10 Suppliers match
                                    </>
                                )}
                            </div>
                            {suppliers_count <= 5 && (
                                <div className="supp-count-subtitle">
                                    Fewer than {suppliers_count} {suppliers_count === 1 ? 'supplier' : 'suppliers'}{' '}
                                    match your criteria. Consider adjusting your filters to include more relevant
                                    matches.
                                </div>
                            )}
                            {suppliers_count >= 6 && suppliers_count <= 9 && (
                                <div className="supp-count-subtitle">
                                    Your selection matches a moderate number of suppliers. You may proceed, or refine
                                    your filters to broaden participation
                                </div>
                            )}
                            {suppliers_count >= 10 && (
                                <div className="supp-count-subtitle">
                                    Your selection matches a ideal number of suppliers. You're ready to proceed
                                </div>
                            )}
                        </div>
                    )}

                    <div className="questionary_modal__main">
                        <div className="questionary_modal__steps">
                            {steps?.map((elem: any, index: number) => {
                                const isActive = elem?.is_active;
                                const isDone = isActive ? false : elem.is_completed;
                                return (
                                    <>
                                        <div
                                            className={`questionary_modal__section 
                                                                            ${
                                                                                isActive
                                                                                    ? 'active'
                                                                                    : isDone
                                                                                    ? 'done'
                                                                                    : 'pending'
                                                                            }
                                                                        `}
                                        >
                                            {isDone ? (
                                                <div className="number_of_section">
                                                    <img src={done} />
                                                </div>
                                            ) : (
                                                <div className="number_of_section">{index + 1}</div>
                                            )}
                                            {elem?.title}
                                        </div>
                                        {index !== steps?.length - 1 && (
                                            <div className="questionary_modal__divider"></div>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                        <div className="questionary_modal__form">
                            <div className="questionary_modal__form-header">
                                <div className="questionary_modal__form-header__row">
                                    <span className="questionary_modal__form-header__row-title">
                                        <img src={ServiceComponentsIcon} /> {form_data?.title}{' '}
                                    </span>
                                    <div className="number-of-section">
                                        Section {steps?.find((elem: any) => elem.is_active)?.key} of {steps?.length}
                                    </div>
                                </div>
                                <div className="questionary_modal__form-header__row description">
                                    {form_data?.description}
                                </div>
                            </div>

                            {saveData?.fields?.map((elem: any) => {
                                const elemFieldKey = fieldInstanceKey(elem.id, elem.component_id);

                                const isCritical = elem?.settings?.find(
                                    (setting: any) => setting.type === 'critical'
                                )?.switchValue;

                                const isMatch = editedField.some(
                                    (item: any) =>
                                        item.id === elem.id &&
                                        (item.component_id == null || item.component_id === elem.component_id)
                                );

                                if (elem?.slug === 'service_components') {
                                    return (
                                        <div className="questionary_modal__formItem formItem">
                                            <div className="formItem__label">{elem?.label}</div>
                                            <div className="formItem__description">{elem.description}</div>
                                            <div>
                                                {service_components?.map((comp: any) => {
                                                    return (
                                                        <div className="questionary_modal__item">
                                                            <Checkbox
                                                                onChange={() =>
                                                                    handleUpdateAnswer(
                                                                        elem?.id,
                                                                        comp?.id,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                checked={elem?.answer?.includes(comp?.id)}
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                            />{' '}
                                                            {comp?.name}{' '}
                                                            <Tooltip title={comp?.description}>
                                                                <div>
                                                                    <InfoIcon fill="#808CB2" />
                                                                </div>
                                                            </Tooltip>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    );
                                } else if (saveData.slug === 'supplier_information') {
                                    return (
                                        <Form form={form} className="questionary_modal__second-form second-form">
                                            <>
                                                {/* provincial_coverage */}
                                                {elem.slug === 'provincial_coverage' && (
                                                    <div className="second-form__block">
                                                        <Form.Item
                                                            className="input-wrapper-multiselect"
                                                            rules={yupSync('provinces', validationSchema, true)}
                                                        >
                                                            <CustomMultiSelect
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                                required={true}
                                                                floatLabel={elem.label}
                                                                err={false}
                                                                className="input-select"
                                                                options={filteredProvincial}
                                                                value={
                                                                    elem.answer?.length > 0
                                                                        ? dataSchoolTypes?.data?.provinces
                                                                              ?.filter((item: any) =>
                                                                                  elem.answer.includes(item.id)
                                                                              )
                                                                              .map((item: any) => ({
                                                                                  id: item.id,
                                                                                  name: item.name
                                                                              }))
                                                                        : []
                                                                }
                                                                onChange={(value: any) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value?.id,
                                                                        'multiple',
                                                                        '',
                                                                        dataSchoolTypes?.data?.provinces,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                hasError={() => errorFields.includes(elemFieldKey)}
                                                                setTouched={() => {}}
                                                                prefix={undefined}
                                                                deleteItem={(value) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value,
                                                                        'multiple',
                                                                        undefined,
                                                                        undefined,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                deleteAllItems={() => {
                                                                    setSaveData((prev: any) => {
                                                                        if (!prev) return prev;

                                                                        return {
                                                                            ...prev,
                                                                            fields: prev.fields.map((field: any) => {
                                                                                if (
                                                                                    isSameFieldInstance(
                                                                                        field,
                                                                                        elem.id,
                                                                                        elem.component_id
                                                                                    ) ||
                                                                                    field.slug === 'sub_region'
                                                                                ) {
                                                                                    return {
                                                                                        ...field,
                                                                                        answer: null
                                                                                    };
                                                                                }

                                                                                return field;
                                                                            })
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Form.Item>
                                                        {errorFields.includes(elemFieldKey) && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '-10px 0 10px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* sub_region */}
                                                {elem.slug === 'sub_region' && (
                                                    <div className="second-form__block">
                                                        <Form.Item
                                                            className="input-wrapper"
                                                            rules={yupSync('sub_regions', validationSchema, true)}
                                                        >
                                                            <CustomMultiSelect
                                                                disabled={
                                                                    !SelectedProvince ||
                                                                    isTREditingForSU ||
                                                                    isTREditingTR
                                                                }
                                                                required={true}
                                                                floatLabel={elem.label}
                                                                err={false}
                                                                className="input-select"
                                                                options={filtredSubRegion}
                                                                value={
                                                                    elem.answer?.length > 0
                                                                        ? subRegionsOptions
                                                                              ?.filter((item: any) =>
                                                                                  elem.answer.includes(item.id)
                                                                              )
                                                                              .map((item: any) => ({
                                                                                  id: item.id,
                                                                                  name: item.name
                                                                              }))
                                                                        : []
                                                                }
                                                                onChange={(value: any) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value?.id,
                                                                        'multiple',
                                                                        '',
                                                                        subRegionsOptions,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                hasError={() => errorFields.includes(elemFieldKey)}
                                                                setTouched={() => {}}
                                                                prefix={undefined}
                                                                deleteItem={(value) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value,
                                                                        'multiple',
                                                                        undefined,
                                                                        undefined,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                deleteAllItems={() => {
                                                                    setSaveData((prev: any) => {
                                                                        if (!prev) return prev;

                                                                        return {
                                                                            ...prev,
                                                                            fields: prev.fields.map((field: any) => {
                                                                                if (
                                                                                    isSameFieldInstance(
                                                                                        field,
                                                                                        elem.id,
                                                                                        elem.component_id
                                                                                    )
                                                                                ) {
                                                                                    return {
                                                                                        ...field,
                                                                                        answer: null
                                                                                    };
                                                                                }

                                                                                return field;
                                                                            })
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Form.Item>

                                                        {errorFields.includes(elemFieldKey) && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '-10px 0 10px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* annual_revenue */}
                                                {elem.slug === 'annual_revenue' && (
                                                    <div className="second-form__block">
                                                        <Form.Item
                                                            className="input-wrapper"
                                                            rules={yupSync('annual_revenue', validationSchema, true)}
                                                        >
                                                            <CustomMultiSelect
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                                required={true}
                                                                floatLabel={elem.label}
                                                                err={false}
                                                                className="input-select"
                                                                options={filteredAnnual}
                                                                value={
                                                                    elem.answer?.length > 0
                                                                        ? dataSchoolTypes?.data?.sc_annual_revenue
                                                                              ?.filter((item: any) =>
                                                                                  elem.answer.includes(item.id)
                                                                              )
                                                                              .map((item: any) => ({
                                                                                  id: item.id,
                                                                                  name: item.name
                                                                              }))
                                                                        : []
                                                                }
                                                                onChange={(value: any) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value?.id,
                                                                        'multiple',
                                                                        '',
                                                                        dataSchoolTypes?.data?.sc_annual_revenue,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                hasError={() => errorFields.includes(elemFieldKey)}
                                                                setTouched={() => {}}
                                                                prefix={undefined}
                                                                deleteItem={(value) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value,
                                                                        'multiple',
                                                                        undefined,
                                                                        undefined,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                deleteAllItems={() => {
                                                                    setSaveData((prev: any) => {
                                                                        if (!prev) return prev;

                                                                        return {
                                                                            ...prev,
                                                                            fields: prev.fields.map((field: any) => {
                                                                                if (
                                                                                    isSameFieldInstance(
                                                                                        field,
                                                                                        elem.id,
                                                                                        elem.component_id
                                                                                    )
                                                                                ) {
                                                                                    return {
                                                                                        ...field,
                                                                                        answer: null
                                                                                    };
                                                                                }

                                                                                return field;
                                                                            })
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Form.Item>

                                                        {errorFields.includes(elemFieldKey) && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '-10px 0 10px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* number_employees */}
                                                {elem.slug === 'number_employees' && (
                                                    <div className="second-form__block">
                                                        <Form.Item
                                                            className="input-wrapper"
                                                            rules={yupSync('employees_number', validationSchema, true)}
                                                        >
                                                            <CustomMultiSelect
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                                required={true}
                                                                floatLabel={elem.label}
                                                                err={false}
                                                                className="input-select"
                                                                options={filteredEmpl}
                                                                value={
                                                                    elem.answer?.length > 0
                                                                        ? dataSchoolTypes?.data?.sc_employees_number
                                                                              ?.filter((item: any) =>
                                                                                  elem.answer.includes(item.id)
                                                                              )
                                                                              .map((item: any) => ({
                                                                                  id: item.id,
                                                                                  name: item.name
                                                                              }))
                                                                        : []
                                                                }
                                                                onChange={(value: any) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value?.id,
                                                                        'multiple',
                                                                        '',
                                                                        dataSchoolTypes?.data?.sc_employees_number,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                hasError={() => errorFields.includes(elemFieldKey)}
                                                                setTouched={() => {}}
                                                                prefix={undefined}
                                                                deleteItem={(value) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value,
                                                                        'multiple',
                                                                        undefined,
                                                                        undefined,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                deleteAllItems={() => {
                                                                    setSaveData((prev: any) => {
                                                                        if (!prev) return prev;

                                                                        return {
                                                                            ...prev,
                                                                            fields: prev.fields.map((field: any) => {
                                                                                if (
                                                                                    isSameFieldInstance(
                                                                                        field,
                                                                                        elem.id,
                                                                                        elem.component_id
                                                                                    )
                                                                                ) {
                                                                                    return {
                                                                                        ...field,
                                                                                        answer: null
                                                                                    };
                                                                                }

                                                                                return field;
                                                                            })
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Form.Item>

                                                        {errorFields.includes(elemFieldKey) && (
                                                            <div
                                                                className="error-text"
                                                                style={{ margin: '-10px 0 10px 0' }}
                                                            >
                                                                This is a required field
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* vat_registered */}
                                                {elem.slug === 'vat_registered' && (
                                                    <div
                                                        className="second-form__block"
                                                        style={{ margin: '10px 0 0 0' }}
                                                    >
                                                        <div className="second-form__title">
                                                            {elem.label}
                                                            <span className="red">*</span>
                                                        </div>

                                                        <Form.Item className="small-input-wrapper">
                                                            <Radio.Group
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                                name="radiogroup"
                                                                className="second-form__radiogroup"
                                                                value={
                                                                    elem.answer === 1
                                                                        ? true
                                                                        : elem.answer === 0
                                                                        ? false
                                                                        : null
                                                                }
                                                                onChange={(e) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem.id,
                                                                        e.target.value,
                                                                        'single',
                                                                        undefined,
                                                                        undefined,
                                                                        elem.component_id
                                                                    )
                                                                }
                                                            >
                                                                <Radio value={true}>Yes</Radio>
                                                                <Radio value={false}>No</Radio>
                                                            </Radio.Group>

                                                            {errorFields.includes(elemFieldKey) && (
                                                                <div
                                                                    className="error-text"
                                                                    style={{ margin: '10px 0 10px 0' }}
                                                                >
                                                                    This is a required field
                                                                </div>
                                                            )}
                                                        </Form.Item>
                                                    </div>
                                                )}
                                                {/* b_bbee */}
                                                {elem.slug === 'b_bbee' && (
                                                    <div className="second-form__block">
                                                        <div className="second-form__title">
                                                            B-BBEE <span className="red">*</span>
                                                        </div>
                                                        <Form.Item
                                                            className="input-wrapper"
                                                            rules={yupSync('b_bbee', validationSchema, true)}
                                                        >
                                                            <CustomMultiSelect
                                                                disabled={isTREditingForSU || isTREditingTR}
                                                                required={true}
                                                                floatLabel={elem.label}
                                                                err={false}
                                                                className="input-select"
                                                                options={filteredBBE}
                                                                value={
                                                                    elem.answer?.length > 0
                                                                        ? dataSchoolTypes?.data?.sc_b_bbee
                                                                              ?.filter((item: any) =>
                                                                                  elem.answer.includes(item.id)
                                                                              )
                                                                              .map((item: any) => ({
                                                                                  id: item.id,
                                                                                  name: item.name
                                                                              }))
                                                                        : []
                                                                }
                                                                onChange={(value: any) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value?.id,
                                                                        'multiple',
                                                                        '',
                                                                        dataSchoolTypes?.data?.sc_b_bbee,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                hasError={() => errorFields.includes(elemFieldKey)}
                                                                setTouched={() => {}}
                                                                prefix={undefined}
                                                                deleteItem={(value) =>
                                                                    handleUpdateSuppInfo(
                                                                        elem?.id,
                                                                        value,
                                                                        'multiple',
                                                                        undefined,
                                                                        undefined,
                                                                        elem?.component_id
                                                                    )
                                                                }
                                                                deleteAllItems={() => {
                                                                    setSaveData((prev: any) => {
                                                                        if (!prev) return prev;

                                                                        return {
                                                                            ...prev,
                                                                            fields: prev.fields.map((field: any) => {
                                                                                if (
                                                                                    isSameFieldInstance(
                                                                                        field,
                                                                                        elem.id,
                                                                                        elem.component_id
                                                                                    )
                                                                                ) {
                                                                                    return {
                                                                                        ...field,
                                                                                        answer: null
                                                                                    };
                                                                                }

                                                                                return field;
                                                                            })
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                )}
                                            </>
                                        </Form>
                                    );
                                } else {
                                    if (elem.type === 'short-answer') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                <div className="Field__input">
                                                    <div className="Field__row">
                                                        <FloatInput
                                                            disabled={
                                                                isTREditingForSU || (isTREditingTR && !isCritical)
                                                            }
                                                            floatLabel={elem.label}
                                                            className="input"
                                                            required={false}
                                                            onChange={(e: any) =>
                                                                updateAnswer(elem.id, e.target.value, elem.component_id)
                                                            }
                                                            value={elem.answer}
                                                            hasError={() => errorFields.includes(elemFieldKey)}
                                                            maxLength={60}
                                                            style={{ width: '600px' }}
                                                        />
                                                        {isCritical && isTREditingTR && <NeedReview />}
                                                    </div>
                                                    {errorFields.includes(elemFieldKey) && (
                                                        <div className="error-text">This field is required</div>
                                                    )}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'paragraph') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                <div className="Field__input">
                                                    <div className="Field__row">
                                                        <FloatTextArea
                                                            disabled={
                                                                isTREditingForSU || (isTREditingTR && !isCritical)
                                                            }
                                                            floatLabel={elem.label}
                                                            className="input"
                                                            hasError={() => errorFields.includes(elemFieldKey)}
                                                            required={false}
                                                            onChange={(e: any) =>
                                                                updateAnswer(elem.id, e.target.value, elem.component_id)
                                                            }
                                                            value={elem.answer}
                                                        />
                                                        {isCritical && isTREditingTR && <NeedReview />}
                                                    </div>
                                                    {errorFields.includes(elemFieldKey) && (
                                                        <div className="error-text">This field is required</div>
                                                    )}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'dropdown') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                {elem.component_name && (
                                                    <div className="Field__component">{elem.component_name}</div>
                                                )}
                                                <div className="Field__row">
                                                    <Form>
                                                        <Form.Item
                                                            className="input-wrapper dropdown-sign-supplier"
                                                            style={{ margin: '10px 0 0 0' }}
                                                        >
                                                            <FloatSelect
                                                                disabled={
                                                                    isTREditingForSU || (isTREditingTR && !isCritical)
                                                                }
                                                                required={false}
                                                                floatLabel={elem?.label}
                                                                err={errorFields.includes(elemFieldKey)}
                                                                setSearch={() => {}}
                                                                options={elem?.options?.map((elem: any) => ({
                                                                    name: elem.label,
                                                                    value: elem.label
                                                                }))}
                                                                onChange={(value: any) =>
                                                                    updateAnswer(
                                                                        elem.id,
                                                                        value?.name,
                                                                        elem.component_id
                                                                    )
                                                                }
                                                                search={''}
                                                                form={undefined}
                                                                hasError={() => !!errorFields.includes(elemFieldKey)}
                                                                type="common"
                                                                value={
                                                                    elem?.answer?.length > 0
                                                                        ? { name: elem?.answer, label: elem?.answer }
                                                                        : ''
                                                                }
                                                                style={{ maxWidth: '600px' }}
                                                            />
                                                        </Form.Item>
                                                        {errorFields.includes(elemFieldKey) && (
                                                            <div className="error-text" style={{ margin: '2px 0 0 0' }}>
                                                                This field is required
                                                            </div>
                                                        )}
                                                    </Form>
                                                    {isCritical && isTREditingTR && <NeedReview />}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'single-select') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                {elem.component_name && (
                                                    <div className="Field__component">{elem.component_name}</div>
                                                )}
                                                <div className="Field__title">
                                                    <div>
                                                        {elem.label}
                                                        {false && <span className="red">*</span>}
                                                    </div>
                                                    {isCritical && isTREditingTR && <NeedReview />}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                <div className="Field__options">
                                                    {elem?.options?.map((option: any) => {
                                                        return (
                                                            <div className="Field__option">
                                                                <Radio
                                                                    disabled={
                                                                        isTREditingForSU ||
                                                                        (isTREditingTR && !isCritical)
                                                                    }
                                                                    onClick={() =>
                                                                        updateAnswer(
                                                                            elem.id,
                                                                            option?.value,
                                                                            elem.component_id
                                                                        )
                                                                    }
                                                                    checked={elem?.answer?.includes(option?.label)}
                                                                    className={elem?.error ? 'red' : ''}
                                                                />
                                                                {option?.label}
                                                            </div>
                                                        );
                                                    })}
                                                    {errorFields.includes(elemFieldKey) && (
                                                        <div className="error-text">This field is required</div>
                                                    )}
                                                </div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'multiple-choice') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                {elem.component_name && (
                                                    <div className="Field__component">{elem.component_name}</div>
                                                )}
                                                <div className="Field__title">
                                                    <div>
                                                        {elem.label}
                                                        {false && <span className="red">*</span>}
                                                    </div>
                                                    {isCritical && isTREditingTR && <NeedReview />}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                <div className="Field__options">
                                                    {elem?.options?.map((option: any) => {
                                                        return (
                                                            <div
                                                                className="Field__option"
                                                                style={{ whiteSpace: 'pre-wrap' }}
                                                            >
                                                                <Checkbox
                                                                    disabled={
                                                                        isTREditingForSU ||
                                                                        (isTREditingTR && !isCritical)
                                                                    }
                                                                    onClick={() =>
                                                                        updateAnswer(
                                                                            elem.id,
                                                                            option?.label,
                                                                            elem.component_id
                                                                        )
                                                                    }
                                                                    checked={elem?.answer?.includes(option?.value)}
                                                                    className={elem?.error ? 'red' : ''}
                                                                />
                                                                {option?.label}
                                                            </div>
                                                        );
                                                    })}
                                                    {errorFields?.includes(elemFieldKey) && (
                                                        <div className="error-text">This field is required</div>
                                                    )}
                                                </div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'explanation-banner') {
                                        return (
                                            <div className="note">
                                                <img src={i} />
                                                {elem?.description}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'file-upload') {
                                        return (
                                            <div className={`Field ${isMatch ? 'edited' : ''}`}>
                                                {elem.component_name && (
                                                    <div className="Field__component">{elem.component_name}</div>
                                                )}
                                                <div className="Field__title">
                                                    <div>
                                                        {elem.label}
                                                        {false && <span className="red">*</span>}
                                                    </div>
                                                    {isCritical && isTREditingTR && <NeedReview />}
                                                </div>
                                                <div className="Field__description">{elem.description}</div>
                                                <div className="Field__filepicker">
                                                    <FilePicker
                                                        disabled={isTREditingForSU || (isTREditingTR && !isCritical)}
                                                        fileList={[elem.answer].filter(Boolean)}
                                                        onChange={(file: any) => {
                                                            if (file?.[0]?.uid) {
                                                                uploadFileHandler(
                                                                    file,
                                                                    saveData?.id,
                                                                    elem.id,
                                                                    elem.component_id
                                                                );
                                                            } else {
                                                                if (!file?.length) {
                                                                    deleteFile(elem.id, elem.component_id);
                                                                }
                                                            }
                                                        }}
                                                        error={
                                                            errorFields?.includes(elemFieldKey)
                                                                ? 'This field is required'
                                                                : ''
                                                        }
                                                        setError={() => {}}
                                                        specialFormats={elem.settings
                                                            ?.find((s: any) => s.type === 'file_upload_formats')
                                                            ?.options?.filter((option: any) => option.selected)
                                                            .flatMap((format: any) =>
                                                                format.label.split(',').map((s: string) => s.trim())
                                                            )}
                                                    />

                                                    {errorFiles?.find((err) => err.key === elemFieldKey)?.error && (
                                                        <div className="error-text">
                                                            {errorFiles?.find((err) => err.key === elemFieldKey)?.error}
                                                        </div>
                                                    )}
                                                </div>
                                                {isMatch && (
                                                    <div className="edited-text">
                                                        <Edit fill="#E3A11F" />
                                                        Edited by Tender Expert
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'group_header') {
                                        return (
                                            <div className="Field">
                                                <div className="Field__slider-title">{elem.label}</div>
                                                <div className="Field__description">{elem.description}</div>
                                            </div>
                                        );
                                    }
                                    if (elem.type === 'slider') {
                                        return (
                                            <div className="expertise">
                                                <label className="expertise__label">{elem.label}</label>
                                                <div
                                                    className={`expertise__slider ${
                                                        errorFields.includes(elemFieldKey) ? 'error' : ''
                                                    }`}
                                                >
                                                    {elem.options.map((option: any, index: number) => {
                                                        const isLast = index === elem.options.length - 1;

                                                        const selected = elem.answer;

                                                        const hasSelectedAfter = elem.options
                                                            .slice(index + 1)
                                                            .some((opt: any) => opt.value === selected);

                                                        return (
                                                            <React.Fragment key={option.value}>
                                                                <button
                                                                    className={`expertise__dot ${
                                                                        isTREditingForSU || isTREditingTR
                                                                            ? 'disable'
                                                                            : ''
                                                                    } ${hasSelectedAfter ? 'done' : ''} ${
                                                                        elem.answer === option.value ? option.label : ''
                                                                    } `}
                                                                    onClick={() => {
                                                                        if (isTREditingForSU || isTREditingTR) return;

                                                                        updateAnswer(
                                                                            elem.id,
                                                                            option.value,
                                                                            elem.component_id
                                                                        );
                                                                    }}
                                                                >
                                                                    <span>{option.label}</span>
                                                                </button>

                                                                {!isLast && (
                                                                    <div
                                                                        className={`expertise__line ${
                                                                            hasSelectedAfter ? 'line--active' : ''
                                                                        }`}
                                                                    ></div>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </div>
                                                {errorFields.includes(elemFieldKey) && (
                                                    <div className="error-text" style={{ margin: '0 0 10px 0' }}>
                                                        This is a required field
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    }
                                }
                            })}
                        </div>
                    </div>
                    <div className="questionary_modal__footer">
                        {steps.findIndex((item: any) => item.is_active) > 0 && (
                            <Button
                                className="tasks__next-btn"
                                style={{ width: '140px', margin: '0 auto 0 0' }}
                                onClick={() => {
                                    const items = [...steps];

                                    const activeIndex = items.findIndex((item) => item.is_active);

                                    const prevId = activeIndex > 0 ? items[activeIndex - 1].key : null;
                                    if (prevId) {
                                        getFormData(prevId);
                                    }
                                }}
                            >
                                <ArrowDown style={{ transform: 'rotate(90deg)' }} /> Previous
                            </Button>
                        )}
                        {isTREditingForSU ? (
                            (() => {
                                const activeIndex = steps.findIndex((item: any) => item.is_active);
                                const nextStep = steps[activeIndex + 1];

                                const nextId = activeIndex < steps.length - 1 ? steps[activeIndex + 1].key : null;

                                return (
                                    activeIndex < steps.length - 1 && (
                                        <Button
                                            className="tasks__next-btn"
                                            style={{ width: '140px', margin: '0 0 0 auto' }}
                                            disabled={nextStep?.is_completed === false}
                                            onClick={() => {
                                                if (nextId) {
                                                    getFormData(nextId);
                                                }
                                            }}
                                            type="primary"
                                        >
                                            Next <ArrowDown style={{ transform: 'rotate(-90deg)' }} />
                                        </Button>
                                    )
                                );
                            })()
                        ) : (
                            <>
                                {isTREditingTR ? (
                                    <></>
                                ) : (
                                    <>
                                        <Button
                                            className="fields__btn"
                                            disabled={isLoadingDiscard}
                                            onClick={handleDiscardChanges}
                                        >
                                            {isLoadingDiscard ? <Loader color="#001965" /> : 'Discard Changes'}
                                        </Button>
                                        <Button className="fields__btn" onClick={() => saveForm('save_and_exit')}>
                                            {isLoadingSave && loadingType === 'save_and_exit' ? (
                                                <Loader color="#001965" />
                                            ) : (
                                                'Save and Exit'
                                            )}
                                        </Button>
                                    </>
                                )}

                                <Button
                                    className="fields__btn"
                                    type="primary"
                                    onClick={() => saveForm('next')}
                                    disabled={
                                        saveData &&
                                        isServiceComponents &&
                                        (!saveData?.fields?.[0]?.answer || saveData?.fields?.[0]?.answer?.length < 1)
                                        // || suppliers_count <= 5
                                    }
                                >
                                    {isLoadingSave && loadingType === 'next' ? (
                                        <Loader />
                                    ) : (
                                        <div className="questionary_modal__btn">
                                            Next <ArrowDown style={{ transform: 'rotate(-90deg)' }} fill="white" />
                                        </div>
                                    )}
                                </Button>
                            </>
                        )}
                    </div>
                </div>
            </Modal>
        </>
    );
};
